// // src/components/Testimonials.js
// import React, { useEffect } from 'react';
// import AOS from 'aos';
// import 'aos/dist/aos.css';
// import 'swiper/swiper-bundle.css';
// import Swiper from 'swiper/bundle';
// import './Testimonials.css'; // Ensure this file exists in the same directory as Testimonials.js

// const Testimonials = () => {
//   useEffect(() => {
//     AOS.init({ duration: 1000 });
//     new Swiper('.swiper-container', {
//       loop: true,
//       autoplay: {
//         delay: 5000,
//         disableOnInteraction: false,
//       },
//       pagination: {
//         el: '.swiper-pagination',
//         clickable: true,
//       },
//     });
//   }, []);

//   return (
//     <section id="testimonials" className="testimonials">
//       <div className="container" data-aos="fade-up">
//         <div className="section-title">
//           <h2>Testimonials</h2>
//           <p>
//             Magnam dolores commodi suscipit. Necessitatibus eius consequatur ex aliquid fuga eum quidem. Sit sint
//             consectetur velit. Quisquam quos quisquam cupiditate. Et nemo qui impedit suscipit alias ea.
//           </p>
//         </div>

//         <div className="testimonials-slider swiper-container" data-aos="fade-up" data-aos-delay="100">
//           <div className="swiper-wrapper">
//             <div className="swiper-slide">
//               <div className="testimonial-wrap">
//                 <div className="testimonial-item">
//                   <img src="./images/testimonials-1.jpg" className="testimonial-img" alt="Saul Goodman" />
//                   <h3>Saul Goodman</h3>
//                   <h4>Ceo &amp; Founder</h4>
//                   <p>
//                     <i className="bx bxs-quote-alt-left quote-icon-left"></i>
//                     Proin iaculis purus consequat sem cure digni ssim donec porttitora entum suscipit rhoncus.
//                     Accusantium quam, ultricies eget id, aliquam eget nibh et. Maecen aliquam, risus at semper.
//                     <i className="bx bxs-quote-alt-right quote-icon-right"></i>
//                   </p>
//                 </div>
//               </div>
//             </div>

//             <div className="swiper-slide">
//               <div className="testimonial-wrap">
//                 <div className="testimonial-item">
//                   <img src="./images/testimonials-2.jpg" className="testimonial-img" alt="Sara Wilsson" />
//                   <h3>Sara Wilsson</h3>
//                   <h4>Designer</h4>
//                   <p>
//                     <i className="bx bxs-quote-alt-left quote-icon-left"></i>
//                     Export tempor illum tamen malis malis eram quae irure esse labore quem cillum quid cillum eram malis
//                     quorum velit fore eram velit sunt aliqua noster fugiat irure amet legam anim culpa.
//                     <i className="bx bxs-quote-alt-right quote-icon-right"></i>
//                   </p>
//                 </div>
//               </div>
//             </div>

//             <div className="swiper-slide">
//               <div className="testimonial-wrap">
//                 <div className="testimonial-item">
//                   <img src="./images/testimonials-3.jpg" className="testimonial-img" alt="Jena Karlis" />
//                   <h3>Jena Karlis</h3>
//                   <h4>Store Owner</h4>
//                   <p>
//                     <i className="bx bxs-quote-alt-left quote-icon-left"></i>
//                     Enim nisi quem export duis labore cillum quae magna enim sint quorum nulla quem veniam duis minim
//                     tempor labore quem eram duis noster aute amet eram fore quis sint minim.
//                     <i className="bx bxs-quote-alt-right quote-icon-right"></i>
//                   </p>
//                 </div>
//               </div>
//             </div>

//             <div className="swiper-slide">
//               <div className="testimonial-wrap">
//                 <div className="testimonial-item">
//                   <img src="assets/img/testimonials/testimonials-4.jpg" className="testimonial-img" alt="Matt Brandon" />
//                   <h3>Matt Brandon</h3>
//                   <h4>Freelancer</h4>
//                   <p>
//                     <i className="bx bxs-quote-alt-left quote-icon-left"></i>
//                     Fugiat enim eram quae cillum dolore dolor amet nulla culpa multos export minim fugiat minim velit
//                     minim dolor enim duis veniam ipsum anim magna sunt elit fore quem dolore labore illum veniam.
//                     <i className="bx bxs-quote-alt-right quote-icon-right"></i>
//                   </p>
//                 </div>
//               </div>
//             </div>
//           </div>

//           <div className="swiper-pagination"></div>
//         </div>
//       </div>
//     </section>
//   );
// };

// export default Testimonials;
// src/components/Testimonials.js
import React from 'react';
import { Link } from 'react-router-dom'; // Import Link from react-router-dom
import './Testimonials.css'; // Ensure this CSS file is created with the styles

const Card = ({ icon, title, description, backDescription }) => (
  <div className="card">
    <div className="card-inner">
      <div className="card-front">
        <i className={`card-icon fas ${icon}`}></i>
        <h3 className="card-title">{title}</h3>
        <p className="card-description">{description}</p>
      </div>
      <div className="card-back">
        <p className="back-description">{backDescription}</p>
        <Link to="/contact-us" className="enroll-button">Enroll</Link> {/* Use Link instead of a */}
      </div>
    </div>
  </div>
);

const Testimonials = () => {
  return (
    <div className="testimonials-container">
      <div className="testimonials-intro">
        <h2>Do You Want to Learn Quran?</h2>
        <h1>We are Bringing Quran Education to Every Home</h1>
        <h3>Online Quran Academy believes that the message of Quran is for everybody. There is no age threshold to learn the Holy Quran.</h3>
      </div>
      <div className="container">
        <Card
          icon="fa-clock"
          title="Desired Timing"
          description="Feeling tired after work? Too busy..."
          backDescription="Feeling tired after work? Too busy in the morning? Resting in the afternoon? No worries! Just tell us your desired timings and we are sure to follow."
        />
        <Card
          icon="fa-handshake"
          title="Collaborative Classes"
          description="Our online teachers try to make a friendly..."
          backDescription="Our online Quran teachers try to make a friendly environment in the class. They allow their students to speak their minds. Moreover, the parents can also advise the teachers. This collaborative approach ensures the speedy learning of the student."
        />
        <Card
          icon="fa-laptop-house"
          title="Any Device, Anywhere"
          description="Online Quran Academy uses the latest..."
          backDescription="Online Quran Academy uses the latest software like Skype and Zoom. You can use these software on any electronic device: computer, smart phone, tablet, etc. We use Screen Sharing option to teach the students. This allows you to take your classes anywhere you like!"
        />
        <Card
          icon="fa-user-edit"
          title="Individual Sessions"
          description="We give every individual special attention..."
          backDescription="We give every single student special attention. We do not prefer large congregations as they are unsuitable for online system. Only one student at a time."
        />
      </div>
    </div>
  );
};

export default Testimonials;
